const RegisterInputData = [
  {
    label: "First Name *",
    name: "FirstName",
  },
  {
    label: "Last Name *",
    name: "LastName",
  },
  {
    label: "Mobile Number *",
    name: "Mobile",
    type: "number",
  },
  { label: "Email Id *", name: "Email" },
  {
    label: "Company Name *",
    name: "CompanyName",
  },
  {
    label: "Shipping Address *",
    name: "ShippingAddress",
    type: "textarea",
  },
  {
    label: "Shipping ZipCode *",
    name: "ShippingZipCode",
    type: "number",
  },
];

const RegisterFormInputData = {
  FirstName: "",
  LastName: "",
  Mobile: "",
  WhatsappNo: "",
  Email: "",
  CompanyName: "",
  ShippingAddress: "",
  ShippingCity: "00",
  ShippingState: "24",
  ShippingCountry: "1",
  ShippingZipCode: "",
  BillingAddress: "",
  BillingCity: "00",
  BillingState: "24",
  BillingCountry: "1",
  BillingZipCode: "",
  NumberCheckbox: true,
  SameAsBilling: true,
  otp: "",
  type: "email",
};

const requiredFields = [
  "FirstName",
  "LastName",
  "Mobile",
  "Email",
  "CompanyName",
  "NatureOfBusiness",
  "ShippingAddress",
  "ShippingCity",
  "ShippingState",
  "ShippingCountry",
  "ShippingZipCode",
];

export { RegisterInputData, RegisterFormInputData, requiredFields };
